module.exports = __webpack_public_path__ + "static/media/7.f99e8e5a.jpg";